import React, { useEffect, useState } from "react";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { toast } from "react-toastify";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import {
  useDeleteServiceGroupMutation,
  useDeleteServiceMutation,
  useGetServiceGroupQuery,
  useGetServicesQuery,
  useRemoveServiceGroupMutation,
} from "../../api/admin/ServiziApi";
import DetailService from "./DetailService";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { useTranslation } from "react-i18next";
import CoreRequestServices from "../../../app/core/components/CoreRequestServices/CoreRequestServices";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar";
import AltriServiziPage from "../AltriServizi/AltriServiziPage";
import { useSelector } from "react-redux";
import { TABS_SERVICES } from "../../../utils/constants/tab_bar";
import CoreIAicon from "../../../app/core/components/CoreIAicon/CoreIAicon";
import CoreViewLists from "../../../app/core/components/CoreViewLists/CoreViewLists";
import { IconButton, Tooltip } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import AddService from "./AddService";
import ServiceTwoLevel from "./ServiceTwoLevel";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";

const ServiziPage = () => {
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [service, setService] = useState(null);
  const [openServiceEditModal, setOpenServiceEditModal] = useState(false);
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [showConfirmRemoveDialog, setShowConfirmRemoveDialog] = useState(false);
  const [openRequestServiceModal, setOpenRequestServiceModal] = useState(false);
  const [confirmDeleteGroupDialog, setConfirmDeleteGroupDialog] =
    useState(false);
  const [selectedTab, setSelectedTab] = useState("services");
  const [openRows, setOpenRows] = useState({});
  const [openAddService, setOpenAddService] = useState(false);
  const [openServiceTwoLevelModal, setOpenServiceTwoLevelModal] =
    useState(false);
  const { data, isLoading, isFetching, refetch } = useGetServicesQuery(page);
  const { data: serviceLevel, refetch: refetchServiceLevel } =
    useGetServiceGroupQuery(undefined, {
      skip: !appConfig?.modules?.services?.serviceTwoLevel,
    });

  const [deleteService] = useDeleteServiceMutation();
  const [deleteGroupService] = useDeleteServiceGroupMutation();
  const [removeServiceGroup] = useRemoveServiceGroupMutation();

  useEffect(() => {
    const isValidation = data && data.Data && data.Data.items;

    const serviceLevelData =
      appConfig?.modules?.services?.serviceTwoLevel &&
      serviceLevel &&
      serviceLevel?.Data;

    // Controllo parametrizzato (serviceWithLLM)
    const filteredItems = appConfig?.modules?.services?.serviceWithLLM
      ? data?.Data?.items
      : data?.Data?.items?.filter((el) => el.aiPrompt === null);

    // Controllo parametrizzato (serviceTwoLevel)
    const filterService = appConfig?.modules?.services?.serviceTwoLevel
      ? filteredItems?.filter((el) => el.practiceServiceCategoryId === null)
      : filteredItems;

    if (isValidation) {
      const serviceData = filterService?.map((el) => ({
        [t("Img")]: (
          <div className="h-24 w-24 flex justify-center items-center overflow-hidden">
            <img
              src={el.iconUrl || "/img/placeholder-image.svg"}
              alt="Immagine"
              style={{
                maxWidth: "90px",
                maxHeight: "90px",
              }}
            />
            <p
              className="absolute flex w-14 justify-end font-bold"
              style={{ marginLeft: "100px", marginTop: "80px" }}
            >
              {el.aiPrompt && <CoreIAicon />}
            </p>
          </div>
        ),
        [t("Name")]: el.name,
        [t("Description")]: el.description,
        [t("Category")]: (
          <CoreViewLists value={el.categories} text={t("DocCategories")} />
        ),
        id: el.id,
        [t("Service")]: el.isForAll ? (
          t("All")
        ) : (
          <CoreChip label={el.activeStudios[0]?.name} variant="outlined" />
        ),
        [t("Activated")]: el.isForAll ? (
          <CoreViewLists value={el.activeStudios} text={t("Studios")} />
        ) : el.activeStudios[0] ? (
          t("Yes")
        ) : (
          t("No")
        ),
        activeStudios: el.activeStudios,
        isForAll: el.isForAll,
        prompt: el.aiPrompt,
        [t("Actions")]: [
          {
            icon: <EditRoundedIcon />,
            onClick: () => handleOpenEditModal(el),
            tooltip: t("Edit"),
            show: true,
          },
          {
            icon: <PostAddRoundedIcon />,
            onClick: () => handleOpen(el),
            tooltip: t("ServiceRequestForUser"),
            show: appConfig?.modules?.services?.servicesRequestsForReferrers,
          },
          {
            icon: <AddBoxRoundedIcon className={`fill-yellow-500`} />,
            onClick: () => handleOpenServiceTwoLevel(el),
            tooltip: t("AddLevel"),
            show: appConfig?.modules?.services?.serviceTwoLevel && el.isForAll,
          },
          {
            icon: <DeleteIcon className={"fill-rose-600"} />,
            onClick: () => handleDeleteService(el),
            tooltip: t("Delete"),
            show: true,
          },
        ].map(
          (action, index) =>
            action.show && (
              <Tooltip title={action.tooltip} key={index}>
                <IconButton variant="outlined" onClick={action.onClick}>
                  {action.icon}
                </IconButton>
              </Tooltip>
            )
        ),
      }));
      setRows(serviceData);
    }

    if (serviceLevelData) {
      const serviceGroup = serviceLevelData?.map((el) => ({
        [t("Img")]: (
          <img
            src={el.iconURL || "/img/placeholder-image.svg"}
            alt="Immagine"
            style={{
              maxWidth: "90px",
              maxHeight: "90px",
            }}
          />
        ),
        [t("Name")]: el.name,
        [t("Description")]: el.description,
        [t("Category")]: "-",
        id: el.id,
        [t("Service")]: el.studioId ? (
          <CoreChip label={el.adminStudio.name} variant="outlined" />
        ) : (
          t("All")
        ),
        [t("Activated")]: "-",
        collapse: el?.practiceServices?.map((el) => ({
          [t("Img")]: (
            <img
              src={el.iconUrl || "/img/placeholder-image.svg"}
              alt="Immagine"
              style={{
                width: "60px",
                maxHeight: "60px",
              }}
            />
          ),
          [t("Name")]: el.name,
          [t("Description")]: el.description,
          id: el.id,
          [t("Actions")]: [
            {
              icon: <EditRoundedIcon />,
              onClick: () => handleOpenEditModal(el),
              tooltip: t("Edit"),
              show: true,
            },

            {
              icon: <DeleteIcon className={"fill-rose-600"} />,
              onClick: () => handleDeleteService(el),
              tooltip: t("Delete"),
              show: true,
            },
            {
              icon: <HighlightOffRoundedIcon className={"fill-orange-500"} />,
              onClick: () => handleRemoveServiceGroup(el),
              tooltip: t("Remove"),
              show: el.isForAll,
            },
          ].map(
            (action, index) =>
              action.show && (
                <Tooltip title={action.tooltip} key={index}>
                  <IconButton variant="outlined" onClick={action.onClick}>
                    {action.icon}
                  </IconButton>
                </Tooltip>
              )
          ),
        })),
        [t("Actions")]: [
          {
            icon: <EditRoundedIcon />,
            onClick: () => handleOpenServiceTwoLevel(el),
            tooltip: t("Edit"),
            show: true,
          },
          {
            icon: <DeleteIcon className={"fill-rose-600"} />,
            onClick: () => handleDeleteGroup(el),
            tooltip: t("Delete"),
            show: true,
          },
          {
            icon: <AddCircleRoundedIcon className={"fill-blue-600"} />,
            onClick: () => handleOpenAddService(el),
            tooltip: t("AddService"),
            show: !el.studioId,
          },
          {
            icon: openRows[el.id] ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            ),
            onClick: () => handleToggleCollapse(el.id),
            tooltip: openRows[el.id] ? t("Close") : t("Open2"),
            show: true,
          },
        ].map(
          (action, index) =>
            action.show && (
              <Tooltip title={action.tooltip} key={index}>
                <IconButton variant="outlined" onClick={action.onClick}>
                  {action.icon}
                </IconButton>
              </Tooltip>
            )
        ),
      }));
      setRows((prevRows) => [...serviceGroup, ...prevRows]);
    }
  }, [data, t, appConfig, serviceLevel, openRows]);

  // Function
  const handleRefecthDocuments = () => {
    refetch();
    if (appConfig?.modules?.services?.serviceTwoLevel) refetchServiceLevel();
  };

  const handleToggleCollapse = (rowId) => {
    setOpenRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Modal
  const handleOpenEditModal = (el) => {
    setService(el);
    setOpenServiceEditModal(true);
  };

  const handleCloseServiceEditModal = () => {
    setService();
    setOpenServiceEditModal(false);
  };

  const handleDeleteService = (el) => {
    setService(el);
    setShowConfirmUserDialog(true);
  };

  const handleDeleteGroup = (el) => {
    setService(el);
    setConfirmDeleteGroupDialog(true);
  };

  const handleRemoveServiceGroup = (el) => {
    setService(el);
    setShowConfirmRemoveDialog(true);
  };

  const handleOpenAddService = (el) => {
    setService(el);
    setOpenAddService(true);
  };

  const handleCloseAddService = () => {
    setOpenAddService(false);
    setService();
  };

  const handleCloseDialod = () => setShowConfirmUserDialog(false);
  const handleCloseRemoveDialod = () => setShowConfirmRemoveDialog(false);
  const handleCloseDeleteDialod = () => setConfirmDeleteGroupDialog(false);

  const handleOpen = (service) => {
    setService(service);
    setOpenRequestServiceModal(true);
  };

  const handleClose = () => {
    setOpenRequestServiceModal(false);
    setService();
  };

  const handleOpenServiceTwoLevel = (el) => {
    setService(el);
    setOpenServiceTwoLevelModal(true);
  };

  const handleCloseServiceTwoLevel = () => {
    setOpenServiceTwoLevelModal(false);
    setService();
  };

  // Dialog
  const handleConfermDialog = async () => {
    deleteService(service.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("ServiceNotDeleted"));
        return;
      }
      toast.success(t("ServiceDeleted"));
      handleCloseDialod();
    });
  };

  const handleConfermRemoveDialog = async () => {
    removeServiceGroup(service.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("ServiceNotRemoved"));
        return;
      }
      toast.success(t("ServiceRemoved"));
      handleCloseRemoveDialod();
    });
  };

  const handleConfermDeleteDialog = async () => {
    deleteGroupService(service.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeletedGroup"));
        return;
      }
      toast.success(t("DeletedGroup"));
      handleCloseDeleteDialod();
    });
  };

  const columns = [
    t("Img"),
    t("Name"),
    t("Description"),
    t("Service"),
    t("Category"),
    t("Activated"),
    t("Actions"),
  ];

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div className="w-full">
      <div className="flex flex-col">
        <div className="flex items-center ">
          <h2 className="font-bold" style={{ width: "200px" }}>
            {selectedTab === "services"
              ? `${t("Services")}`
              : `${t("OtherServices")}`}
          </h2>
          {appConfig?.modules?.services?.otherServices && (
            <CoreTabBar tab={TABS_SERVICES()} setSelectedTab={setSelectedTab} />
          )}
        </div>
      </div>
      {selectedTab === "services" && (
        <>
          <div>
            <CoreButtonHoverIcon
              onClick={handleRefecthDocuments}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            <CoreButtonHoverIcon
              className="text-blue-700 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={t("Services")}
              onClick={() => handleOpenEditModal(null)}
            />
          </div>

          <div className="py-5 ">
            <CoreTable
              collapse={true}
              openRows={openRows}
              rows={rows}
              columns={columns}
              info={t("Services")}
              setPage={setPage}
              page={page}
              totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
              isLoading={isLoading || isFetching}
            />
          </div>
        </>
      )}
      {selectedTab === "otherservices" && <AltriServiziPage />}

      <CoreModal
        width={"70%"}
        height={"80%"}
        state={openServiceEditModal}
        onClose={handleCloseServiceEditModal}
        component={
          <DetailService
            handleClose={handleCloseServiceEditModal}
            service={service}
          />
        }
      />

      <CoreModal
        width={"70%"}
        height={"80%"}
        state={openServiceTwoLevelModal}
        onClose={handleCloseServiceTwoLevel}
        component={
          <ServiceTwoLevel
            data={service}
            onClose={handleCloseServiceTwoLevel}
          />
        }
      />

      <CoreModal
        width={700}
        height={600}
        state={openRequestServiceModal}
        onClose={handleClose}
        component={
          <CoreRequestServices
            onClose={handleClose}
            selectedService={service}
          />
        }
      />

      <CoreModal
        width={500}
        height={400}
        state={openAddService}
        onClose={handleCloseAddService}
        component={
          <AddService
            dataService={data?.Data?.items
              ?.filter((el) => el.isForAll)
              ?.filter((el) => el.practiceServiceCategoryId === null)}
            isLoading={isLoading}
            group={service}
            onClose={handleCloseAddService}
          />
        }
      />

      <CoreDialog
        open={showConfirmUserDialog}
        title={t("Delete") + " " + t("service")}
        content={`${t("ServiceDeletingConfirm")} ${service?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDialod}
      />
      <CoreDialog
        open={showConfirmRemoveDialog}
        title={t("RemoveService")}
        content={`${t("RemoveConfirm")} ${service?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermRemoveDialog}
        closeDialog={handleCloseRemoveDialod}
      />
      <CoreDialog
        open={confirmDeleteGroupDialog}
        title={t("Delete") + " " + t("serviceTwoLevel")}
        content={`${t("DeleteConfirm")} ${service?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDeleteDialog}
        closeDialog={handleCloseDeleteDialod}
      />
    </div>
  );
};

export default ServiziPage;
